import { gql } from '@apollo/client';

export const GET_COMPANY_METADATA = gql`
  query GetCompanyMetadata($clerkId: String!) {
    Company(where: { clerkId: { _eq: $clerkId } }) {
      id
      name
      clerkSlug
      metadata
      createdAt
      updatedAt
    }
  }
`;
